import AccountLayout from './account-layout';

export default AccountLayout;